import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import { decline } from 'core/utils';
import { CargoType } from 'types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import ButtonControl from 'components/ButtonControl';
import InputControl from 'components/InputControl';
import CargosStore from 'stores/CargosStore';
import CategoryStore from 'stores/CategoryStore';
import ActionCreators from 'actions/ActionCreators';
import Regexps from 'constants/Regexps';
import TipControl from 'components/TipControl';

import './CargosInfo.scss';

function getStateFromStores() {
    return {
        totalMeasurements: CargosStore.getTotalMeasurements(),
    }
}

class CargosInfo extends Component {

    static propTypes = {
        onChange: PropTypes.func,
        cargos: PropTypes.objectOf(CargoType),
        toAllCargos: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);

        var storeStates = this._normalizeTotalMeasurements(getStateFromStores());

        this.state = {
            ...storeStates,
        }
    }

    componentDidMount() {
        CargosStore.addChangeListener(this._onChange);
    }

    componentWillUnmount() {
        CargosStore.removeChangeListener(this._onChange);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.totalMeasurements !== this.state.totalMeasurements
            || nextState.totalWeight !== this.state.totalWeight
            || nextState.totalVolume !== this.state.totalVolume) {
            return true;
        }

        return false;
    }

    _onChange = () => {
        const storeStates = getStateFromStores();

        this.setState(this._normalizeTotalMeasurements(storeStates));
    }

    _normalizeTotalMeasurements = (storeStates) => {
        let totalWeight = storeStates.totalMeasurements.get('total_weight');
        let totalVolume = storeStates.totalMeasurements.get('total_volume');

        totalWeight = Math.round(totalWeight * 100) / 100; // toFixed(2 or less)
        totalVolume = Math.round(totalVolume * 100) / 100; // toFixed(2 or less)

        return (Object.assign(
            storeStates,
            {
                'totalWeight': totalWeight,
                'totalVolume': totalVolume,
            }
        ));
    }

    _onTotalWeightChange = (event) => {
        let value = event.target.value;
        value = value.replace(/,/g, ".");

        if (this._validateFloat(value)) {
            this.setState({
                'totalWeight': value
            })
        } else {
            return false;
        }
    }

    _onTotalVolumeChange = (event) => {
        let value = event.target.value;
        value = value.replace(/,/g, ".");

        if (this._validateFloat(value)) {
            this.setState({
                'totalVolume': value
            })
        } else {
            return false;
        }
    }

    _validateFloat = (value) => {
        if ((Regexps['FLOAT'].test(value) && value < Number.MAX_SAFE_INTEGER) || !value) {
            return true;
        }

        return false;
    }

    _changeParameters = () => {
        ActionCreators.changeTotalMeasurements(true);
    }

    _saveParameters = () => {
        const totalWeight = this.state.totalWeight;
        const totalVolume = this.state.totalVolume;

        ActionCreators.setTotalMeasurements(totalWeight, totalVolume);
    }

    _cancelChangeParameters = () => {
        this.setState({
            'totalVolume': this.state.totalMeasurements.get('total_volume'),
            'totalWeight': this.state.totalMeasurements.get('total_weight')
        });

        ActionCreators.changeTotalMeasurements(false);
    }

    _renderTotalMeasurements = () => {
        const isReadOnly = !this.state.totalMeasurements.get('is_changeable');

        return (
            <div>
                <label className="CargosInfo-parameter">
                    <span>Общий объём:</span>
                    <div>
                        <InputControl className="CargosInfo-inputControl"
                            onChange={this._onTotalVolumeChange}
                            value={this.state.totalVolume}
                            readOnly={isReadOnly} />
                        <span className="CargosInfo-measure">м<sup>3</sup></span>
                    </div>
                </label>
                <label className="CargosInfo-parameter">
                    <span>Общий вес:</span>
                    <div>
                        <InputControl className="CargosInfo-inputControl"
                            onChange={this._onTotalWeightChange}
                            value={this.state.totalWeight}
                            readOnly={isReadOnly} />
                        <span className="CargosInfo-measure">кг</span>
                    </div>
                </label>
            </div>
        )
    }

    _renderButtons = () => {
        const tipControlClass = classNames(
            'CargosInfo-tipControl',
            { 'CargosInfo-tipControl--hide': this.props.cargos.size }
        );

        if (this.state.totalMeasurements.get('is_changeable')) {
            return (
                <div className="CargosInfo-buttons CargosInfo-buttons--flex">
                    <ButtonControl className="CargosInfo-cancel"
                        view="blackLink"
                        onClick={this._cancelChangeParameters}>
                        Отменить
                    </ButtonControl>
                    <ButtonControl
                        view="darkStone"
                        onClick={this._saveParameters}>
                        Сохранить
                    </ButtonControl>
                </div>
            )
        } else {
            return (
                <div className="CargosInfo-buttons">
                    <ButtonControl className="CargosInfo-button"
                        view="darkStone"
                        onClick={this._changeParameters}
                        disabled={!this.props.cargos.size}>
                        <span>Изменить общие объём и&nbsp;вес</span>
                        <TipControl className={tipControlClass}
                            label="Сначала добавьте груз" />
                    </ButtonControl>
                </div>
            )
        }
    }

    render() {
        var cargosInfoClass = classNames(this.props.className, 'CargosInfo');
        var totalCargos = this.props.cargos.size;
        var totalMeasurementsBlock;
        var buttonsBlock;

        if (CategoryStore.getSelected().id === 'moving') {
            totalMeasurementsBlock = this._renderTotalMeasurements();
            buttonsBlock = this._renderButtons();

            if (this.props.cargos.size > 0) {
                totalCargos = 0;
                const cargos = this.props.cargos.toJS();

                cargos.forEach(function(item) {
                    totalCargos += item.attributes.quantity.value;
                });
            }
        }

        return (
            <div className={cargosInfoClass}>
                <div className="CargosInfo-quantity">
                    <span className="CargosInfo-totalTitle">
                        {decline(totalCargos, ['Добавлен', 'Добавлено', 'Добавлено']) + ':' + ' '}
                    </span>
                    <span className="CargosInfo-totalCargos" onClick={this.handlerToAllCargos}>
                        {totalCargos + ' ' + decline(totalCargos, ['груз', 'груза', 'грузов'])}
                    </span>
                </div>
                {totalMeasurementsBlock}
                {buttonsBlock}
            </div>
        );
    };

    handlerToAllCargos = (e) => {
        e.stopPropagation();
        if (this.props.toAllCargos) this.props.toAllCargos(e);
    };
}

export default CargosInfo;



// WEBPACK FOOTER //
// ./client/components/CargosInfo/CargosInfo.js